import KnowledgeHubFiles from '@/modules/Workspaces/KnowledgeHub/Files/KnowledgeHubFiles.vue'
import HubPage from '@/modules/Workspaces/KnowledgeHub/Hubs/HubPage.vue'
import HubsListPage from '@/modules/Workspaces/KnowledgeHub/Hubs/HubsListPage.vue'
import KnowledgeHubHome from '@/modules/Workspaces/KnowledgeHub/KnowledgeHubHome.vue'
import TopBar from '@/modules/Workspaces/KnowledgeHub/Layout/NavigationBar.vue'
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

const getBreadcrumbsProps =
  ({ hideLinks }: { hideLinks: boolean }) =>
  (route: RouteLocationNormalized) => ({
    hideLinks: hideLinks,
    workspaceId: route.params.workspaceId,
    hubId: route.params.hubId,
  })

const knowledgeRoute: RouteRecordRaw = {
  path: 'knowledge',
  name: 'Knowledge',
  redirect: { name: 'Files' },
  children: [
    {
      path: 'integrations',
      name: 'Integrations',
      components: { BreadCrumbs: TopBar, default: KnowledgeHubHome },
      props: { BreadCrumbs: getBreadcrumbsProps({ hideLinks: false }) },
    },
    {
      path: 'hubs',
      redirect: { name: 'Hubs' },
      props: { BreadCrumbs: getBreadcrumbsProps({ hideLinks: false }) },
      children: [
        {
          path: '',
          name: 'Hubs',
          components: { BreadCrumbs: TopBar, default: HubsListPage },
          props: { BreadCrumbs: getBreadcrumbsProps({ hideLinks: false }) },
        },
        {
          path: ':hubId',
          name: 'Hub',
          components: { BreadCrumbs: TopBar, default: HubPage },
          props: {
            BreadCrumbs: getBreadcrumbsProps({ hideLinks: false }),
            default: (route) => ({
              workspaceId: route.params.workspaceId,
              hubId: route.params.hubId,
            }),
          },
        },
      ],
    },
    {
      path: 'files',
      name: 'Files',
      components: { BreadCrumbs: TopBar, default: KnowledgeHubFiles },
      props: { BreadCrumbs: getBreadcrumbsProps({ hideLinks: false }) },
    },
  ],
}

export const knowledgeRoutes: RouteRecordRaw[] = [knowledgeRoute]
